import img from './img';
import audio from './audio';
import gameData from './gameData.config.js';

var config = {
  author: 'TR',
  engine: 'Memory',
  icon: 'Dusty', //['Dusty', 'Chester', 'Poppy'],
  title: [
    {
      text: 'Look, point and find.',
      // audio: 'games/page010_game2/audio/008P_Look listen and match.mp3',
      cssStyle: { height: '7%', 'font-family': 'Linotype' },
    },
  ],
  gameConfig: gameData,
  checkGameSound: {
    positive: [
      'games/page010_game2/audio/M_Brilliant.mp3',
      'games/page010_game2/audio/M_Excellent.mp3',
      'games/page010_game2/audio/M_Fantastic.mp3',
      'games/page010_game2/audio/M_Great.mp3',
      'games/page010_game2/audio/M_Perfect.mp3',
      'games/page010_game2/audio/M_Very good.mp3',
      'games/page010_game2/audio/M_Well done.mp3',
    ],
    negative: [
      'games/page010_game2/audio/M_Think again.mp3',
      'games/page010_game2/audio/M_Try again.mp3',
      'games/page010_game2/audio/M_Work harder.mp3',
    ],
  },
  // checkGameText: {
  // positive: 'Ćwiczenie zostało wykonane. Brawo!',
  // negative: '',
  // },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
